import { HttpClient } from "@angular/common/http";
import { computed, inject, Injectable, signal } from "@angular/core";
import { AppConfigService, httpOptions, Log } from "@core/services/config/app-config.service";
import { BannerPromoData } from "./banner-promo-data";
import { take } from "rxjs";

@Injectable( { providedIn: 'root' } )
export class BannerPromoService {

    private readonly http = inject( HttpClient );
    private readonly appConfig = inject( AppConfigService );

    private readonly _data = signal<BannerPromoData | null>( null );

    lang: string = '';
    domain: string = '';

    readonly showBanner = computed( () => this._data()?.show_banner === 1 );
    readonly showPopup = computed( () => this._data()?.show_popup === 1 );
    readonly titolo = computed( () => this._data()?.titolo ?? '' );
    readonly testo = computed( () => this._data()?.testo ?? '' );

    constructor() {
        this.lang = this.appConfig.lang();
        this.domain = this.appConfig.domain();
        
        this.getPopUp( )
            .pipe( take( 1 ) )
            .subscribe( popup => {
                this._data.set( Object.keys( popup ).length > 0 ? popup : null );
            } );
    }

    private getPopUp() {
        return this.http.get<BannerPromoData>(this.appConfig.apiUrl() + '/getPopUp/' + this.lang + '/' + this.domain, httpOptions);
    }
}